import { Toast } from 'vant';
import { isLogin } from "@/common/script/auth";
import moment from 'moment';


export async function appRegisterReady() {
    return new Promise((resolve)=> {
        if (window.appIsRegister) {
            resolve('success')
        } else {
            window.addEventListener('appRegisterReady', () => {
                resolve('success')
            })
        }
    });
}

export function openBookMallDetail(bookid: string, book_id: string):void {
    const obj = {
        json_url: `${process.env.VUE_APP_HOST1}/dynb/book_mall_detail_top?bookid=${bookid}`,
        web_url: `${process.env.VUE_APP_HOST}/booksDetail/${book_id}`,
        command: "open_book_mall_detail",
        bookid
    }
    if (window.AndroidWebViewJavascriptBridge ) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        location.href = obj.web_url;
    }
}

// 去开通年度vip会员
export function openYearVip( playUrl: string):void {

    const obj = {
        command:"openview",
        url: playUrl,
        // needcloseself: true,
        needloginalert: 'true'
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        if (!isLogin(playUrl)) {
            return;
        }
        location.href = playUrl;
    }
}

export function openNewVip():void {
    const url = `${process.env.VUE_APP_HOST}/vips?_app_template=fullscreen&_app_fullscreen=true`;
    const obj = {
        command:"openview",
        url,
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        location.href = url;
    }
}

// 会员页面
export function openVip(iosa =false, grade = '1a'):void {
    let url = `${process.env.VUE_APP_HOST}/vips?_app_template=fullscreen&_app_fullscreen=true&grade=${grade}`;
    // let url = `${process.env.VUE_APP_HOST}/vips?renew=true`;
    if (iosa) {
        url += '&iosa=1'
    }
    const obj = {
        command:"openview",
        url,
        // needcloseself: true
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        // if (!isLogin(url)) {
        //     return;
        // }
        // const sessinid = cookies.get('sessionid');
        location.href = url;
    }
}

// 续费会员页面Old
export function openOldVip(iosa =false):void {
    let url = `${process.env.VUE_APP_HOST}/vipsOld?renew=true&_app_template=fullscreen&_app_fullscreen=true`;
    // let url = `${process.env.VUE_APP_HOST}/vips?renew=true`;
    if (iosa) {
        url += '&iosa=1'
    }
    const obj = {
        command:"openview",
        url
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        // if (!isLogin(url)) {
        //     return;
        // }
        // const sessinid = cookies.get('sessionid');
        location.href = url;
    }
}

// 去开通季度（月度）会员支付宝
export function alipayOpenVip(order_info: any, return_url: string):void {
    // const url = `${process.env.VUE_APP_HOST}/vips?renew=true`
    const obj: any = {
        command: 'alipay',
        paydata:{
            return_url,
            order_info
        }
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 自动续费会员管理
export function autoMember(id: number):void {
    const url = `${process.env.VUE_APP_HOST3}/pay/contract_manage/?product_id=${id}`
    const obj = {
        command:"openview",
        url
    }
    console.log(obj);
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        if (!isLogin(url)) {
            return;
        }
        location.href = url;
    }
}

// 有声产品详情
export function audioDetail(item: any):void {
    const obj = {
        command: 'open_listen_detail',
        book_item:item
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 关闭页面
export function closeView(viewName = ''):void {
    const obj: any = {
        command: 'closeview',
    }
    if (viewName) {
        obj.view_name = viewName;
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

// 同时关闭多个viewName相同的页面
export function closeViewAll(viewName = ''):void {
    const obj: any = {
        command: 'closeall',
    }
    if (viewName) {
        obj.view_name = viewName;
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

// 关闭页面
export function closePopup():void {
    const obj = {
        command: 'closepopup',
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        console.log('')
    }
}

// 全部有声
export function audioAll():void {
    const obj = {
        command: 'dy_listen_book_list',
    }

    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 点读详情
export function readDetail(item: any):void {
    const oral_test_ready = Number(item.evaluation);
    const obj = {
        command: 'app_action',
        experience: false,
        bookid: item.bookid,
        oral_test_ready,
        // productId: 买过得书需要传
        name: "openclickread",
        book_item: item
    }
    console.log(obj);
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 全部点读
export function readAll():void {
    const obj = {
        type: "schoolbook",
        command: "app_action",
        name: "tape",
        is_vip_free: true
    }
    console.log(obj);
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }

    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }

}


// 口语评测详情
export function evaluatingDetail(item: any):void {
    // console.log(item);
    const obj = {
        command:"openview",
        // url:`${process.env.VUE_APP_HOST3}/lesson/oral_test?lesson_id=${item.lesson_id}&show_choice=1`,
        url: item.oral_url
    }
    console.log(obj);
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 全部口语评测（推荐）
export function evaluatingAll(grade: string):void {
    if (!grade) {
        grade = '1a'
    }
    const obj = {
        command:"openview",
        url:`${process.env.VUE_APP_HOST3}/dy/oral_test_redirect?_app_template=fullscreen_notitle&chn=app-banner-adv&grade=${grade}`,
    }
    console.log(obj);
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 会员设置（暂时未用）
export function userMember():void {
    const obj = {
        command: 'playoperate',
        playstatus: 'pause',
        mode: "clickread"
    }
    console.log(obj);
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 打开app 弹框
export function appPopup(id: number):void {

    const obj = {
        command: 'app_popup',
        url: `${process.env.VUE_APP_HOST}/booksDetailPop/${id}`,
        topMargin: 0.8,
        leftMargin: 0,
        widthPercent: 1,
        heightPercent: 0.2,
        filletRadius: 20,
        dy_corner_radius: [20,20,0,0],
        bgColor: '#ffffff'
    }

    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
        console.log(obj);
    }
}


// 更新弹框高度
export function appUpdatePopupHeight(height: number, heightPercent: number, radiusTop: number):void {
    const obj = {
        command: 'update_alert_height',
        height,
        heightPercent, // 安卓需要
        radiusTop // 安卓需要
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
        console.log(obj);
    }
}

// 关闭弹框(有疑问)
export function closePop():void {
    const obj = {
        command: 'closeview',
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast('请在APP中打开')
    }
}

// 关闭弹框
export function closePop2():void {
    const obj = {
        command: 'close_popup',
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        // Toast('请在APP中打开')
    }
}



export function customerService(massage: string):void {
    const obj = {
        command : "app_action",
        scene : "user",
        name : "kefu",
        phonenum : "02168900277",
        robot_message: massage
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        // Toast('请在APP中打开')
    }
}

// 通过webView打开HTML5地址
export function openView(url: string, needLoginAlert = false, close = false, viewName = ''):void {
    const obj: any = {
        command:"openview",
        url
    }
    if (needLoginAlert) {
        obj.needloginalert = String(needLoginAlert);
    }
    if (close) {
        obj.needcloseself = true;
    }
    if (viewName) {
        obj.view_name = viewName;
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
      if (needLoginAlert) {
        if (!isLogin(url)) {
          return;
        }
      }
      location.href = url;
    }
}

export function tgaEvent(event_name: string, properties: any) {
  action({
    command: 'tga_event',
    event_name,
    properties
  })
}

// 传入action 调用app
export function action(action: any, isNotAPPToast = true, callback: any = undefined):void {
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(action));
    }

    if (window.WebViewJavascriptBridge) {
        if (callback) {
            window.WebViewJavascriptBridge.send(action, callback);
        } else {
            window.WebViewJavascriptBridge.send(action);
        }
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        if (!isNotAPPToast) {
            Toast('请在APP中打开');
        }
        console.log(action);
    }
}




interface ShareData{
    share_friend: string; // 分享朋友圈标题
    url_image?: string; // 分享图片
    share_title: string; // 分享标题
    share_content: string; // 分享内容
    url_link: string; // 分享链接
    share_list?: string[]
}

// 显示APP右上角分享按钮
export function showShareBtn():void {
    const obj = {
        'command': 'menucontrol',
        'menu_action': [
            { id: '10011'}
        ]
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        console.log(obj);
    }
}

/**
 * 显示APP右上角分享按钮
 * @param shareData
 * @param trackParams 用于埋点的参数
 */
export function showShareMenu(shareData: ShareData, trackParams: any = {}):void {

    const obj: any = {
        "command": "dy_wxshare",
        "share_friend": shareData.share_friend,
        "url_image": shareData.url_image,
        "share_title": shareData.share_title,
        "share_content": shareData.share_content,
        "url_link": shareData.url_link,
        ...trackParams,
    }
    if (shareData.share_list) {
        obj.sharelist = shareData.share_list
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        console.log(obj);
        Toast('请在APP中打开')
    }
}

// 已经获取的勋章展示
export function enterMedal(medal: any):void {
    const obj = {
        command: "get_new_medal",
        message: {
            medal_url: medal.shareImg,
            medal_name: medal.name,
            medal_url_lottie: medal.ico,
            medal_content: medal.yesText,
            medal_getTime: medal.date + '获得',
            medal_description: medal.shareText,
            dy_download_2code_img: "https://f.diyiedu.com/dynb/img/report_qrcode.png"
        },
        sharelist:[
            "SHARE_TYPE_GrowthZone",//成长圈
            "SHARE_TYPE_WX_FRIEND",//微信好友
            "SHARE_TYPE_WX_Timeline",//微信朋友圈
            "SHARE_TYPE_Weibo",//微博
            "SHARE_TYPE_QQ",//QQ
            "SHARE_TYPE_QQZone",
        ],
        content_type: "勋章广场",
        content: "我在勋章广场获得了“" + medal.name + "”荣誉勋章，快来看看吧",
        post_type: "海报帖",
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        console.log(obj);
        Toast('请在APP中打开')
    }
}

// 领取勋章
export function getMedal(medal: any, courseId: number):void {
    const obj =  {
        command:"app_action",
        name:"medal_receive",
        medal_msg: {
            // user_name: real_name,
            // user_headimg: head_img,
            medal_name:  medal.name,
            total_progress: medal.target_ex,
            desc: medal.noText,
            done_desc: medal.yesText,
            share_desc: medal.shareText,
            medal_img: medal.ico,
            share_medal_img: medal.ico,
            url: process.env.VUE_APP_HOST3 + "/vschool/receive_medal?vs_class_id="+ courseId +"&task_id=" + medal.task_id,
            dy_download_2code_img: "https://f.diyiedu.com/dynb/img/report_qrcode.png"
        }
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        console.log(obj);
        Toast('请在APP中打开')
    }
}

// 注册广播命令
export function registerCommand(message_name: string[]):void {
    const obj =  {
        command: "register",
        message_name
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

// 发送广播放命令
export function sendBroadCast(message: string, params: any = null):void {
    const obj = {
        command:"message",
        message
    }
    if (params) {
      Object.assign(obj, params);
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

// 播放音乐
export function playAudio(url: string):void {
    const obj =  {
        command: 'playaudio',
        url,
        mode: 'clickread',
        tipname: 'word',
        index : '0' ,
        recache: false,
        duration: '3',
        begintime: '',
        endtime: ''
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

// 播放背景音乐
export function playBgAudio(url: string):void {
    const obj =  {
        command: 'play_background_audio',
        url,
        mode: 'clickread',
        tipname: 'word',
        index : '0' ,
        recache: false,
        duration: '3',
        begintime: '',
        endtime: '',
        'repeats': -1
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

export function downloadNamibox():void {
    const obj =  {
        'command': 'dy_open_market',
        'ios_url': 'https://apps.apple.com/cn/app/id913503440',
        'android_url': 'http://a.app.qq.com/o/simple.jsp?pkgname=com.jinxin.namibox'
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        if (clientType() === 'ios') {
            location.href = obj.ios_url
        } else {
            location.href = obj.android_url;
        }
        // Toast('请在APP中打开')
    }
}

export function downloadApp():void {
    const obj =  {
        'command': 'dy_open_market',
        'ios_url': 'https://apps.apple.com/cn/app/id1560092642',
        'android_url': 'http://a.app.qq.com/o/simple.jsp?pkgname=com.dyedu.hxedu',
        'harmony_url':'store://appgallery.huawei.com/app/detail?id=com.dyedu.hxedu.hm'
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        if (clientType() === 'ios') {
            location.href = obj.ios_url
        } else {
            location.href = obj.android_url;
        }
        // Toast('请在APP中打开')
    }
}

export function isPc():boolean {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
       return false;
    }
    return true;
}

// 是否是 IOS
export function isIphone():boolean {
    const u = navigator.userAgent;
    //判断是否是 iOS终端
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return isIOS;
}

export function isHarmony() {
    return isAPP() && clientType() === 'harmony';
}

export function isAPP():boolean {
    if (
      navigator.userAgent.toLowerCase().indexOf('nbdiyi') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('diyisdk') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('talkjoy') !== -1
    ) {
        return true;
    }
    return false;
}

export function isTalkJoy() {
    return navigator.userAgent.toLowerCase().indexOf('talkjoy')!== -1;
}

export function isDiyiSdk() {
    if (
      navigator.userAgent.toLowerCase().indexOf('diyisdk') !== -1
    ) {
        return true;
    }
    return false;
}

/**
 * 判断当前是否在企业微信中
 * */
export function isQwWechat(): boolean {
    if (!navigator) return false;
    return !!navigator.userAgent.toLowerCase().match(/wxwork/i);
}

/**
 * 判断当前是否在微信中（不包括企业微信）
 * */
export function isWechat(): boolean {
    if (!navigator) return false;
    return !!navigator.userAgent.toLowerCase().match(/MicroMessenger/i) && !isQwWechat();
}

export function clientType(): string {

    if (navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.indexOf('Adr') > -1 ) {
        return 'android';
    }

    // HarmonyNext
    if (navigator.userAgent.toLowerCase().indexOf('openharmony') > -1 || navigator.userAgent.toLowerCase().indexOf('arkweb') > -1 ) {
        return 'harmonyNext';
    }

    if (navigator.userAgent.toLowerCase().indexOf('harmony') > -1 ) {
        return 'android';
    }

    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return 'ios';
    }
    return 'other';
}
// 调起弹框登陆
export function webNeedLogin():void {
    const obj = {
        command:"webNeedLogin"
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}
// 页面登陆
export function openLoginView():void {
    const obj = {
        command:"openloginview"
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}
// 页面强制退出登陆（目前偶尔出现设置*.diyiedu.com,的sessionid不存在）
export function dylogout(): void {
    const obj = {
        command:"dy_relogin"
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}


// toast
export function appToast(text: string):void {
    const obj = {
        command:"showtips",
        content: text
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
    if (!window.AndroidWebViewJavascriptBridge && !window.WebViewJavascriptBridge) {
        Toast(text)
    }
}

// 刷新设备(会员活动中用到)
export function setupOldDevice():void {
    const obj = {
        command:"setupOldDevice"
    }
    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

// 打开弹框命令
export function popListenMedal(data: any) {
    const obj = {
        command: 'show_read_medal',
        obtined: true,
        medal_name: data.medal_name,
        image:data.image,
        wing_image: data.wing_image,
        dy_description: data.dy_description,
        share_description: data.share_description,
        get_description: data.get_description,
        not_have_description: data.not_have_description,
        remark: data.remark,
        obtined_date: data.get_medal_time.length ? moment(data.get_medal_time[0]).format('YYYY.MM.DD') + '获得': '', // todo 连续排名时间隐藏问题
        confirm_text: '分享我的勋章',
        confirm_action: {
            command:"openview",
            url: `${process.env.VUE_APP_HOST}/listen_medal_share?_app_template=fullscreen_notitle&_app_fullscreen=true`
        }
    }

    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }
    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}

// 滚动截图
export function screenshot(isCanvas = false, rate = 0, shareList: string[] = [], key = '') {
  const obj: any = {
    command: 'screenshot',
    // foot_url: '',
    rate, // 宽高比 例：0.3
    is_add_logo: false,
    iscanvas: isCanvas,
    type: 'no_thumbnails',
    key
  }

  if (!shareList.length) {
    obj.sharelist = [
      "SHARE_TYPE_WX_FRIEND",//微信好友
      "SHARE_TYPE_WX_Timeline",//微信朋友圈
      "SHARE_TYPE_QQ",//QQ
      "SHARE_TYPE_QQZone",
    ];
  } else {
    obj.sharelist = shareList
  }

  if (window.AndroidWebViewJavascriptBridge) {
      prompt(JSON.stringify(obj));
  }
  if (window.WebViewJavascriptBridge) {
      window.WebViewJavascriptBridge.send(obj);
  }
}

// 隐藏(显示)返回按钮
export function setBackBtn(hidden = true) {

    const obj = {
        command: "dy_show_back_btn",
        hidden
    }

    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }

    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }

}

// 设置webview是否可以进行滚动
export function enableScrollWebview(status = false) {

    const obj = {
        command: "dy_scroll_enable_webview",
        enable: status
    }

    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }

    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }

}

// 设置webview 退出有弹框提示
export function backPoint() {
    const obj = {
        command: "backcontrol",
        action: "page_quit"
    }

    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }

    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}
// 获取开启全屏模式下，APP返回的头部安全距离
export function getStatusBarHeight(routerQuery: any) {
    const statusBarHeight = routerQuery.statusBarHeight;
    if (statusBarHeight) {
        if (Array.isArray(statusBarHeight)) {
            return Number(statusBarHeight[0]);
        } else {
            return Number(statusBarHeight)
        }
    }
    return 0;
}

// 跳转微信客服聊天框
export function goWechatService(entry: string) {
    const obj = {
      command: "open_customer_service_page",
      needloginalert: "true",
      extension: {
        entry
      }
    }

    if (window.AndroidWebViewJavascriptBridge) {
        prompt(JSON.stringify(obj));
    }

    if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.send(obj);
    }
}
